// extracted by mini-css-extract-plugin
module.exports =  {"single-review":"tr7oBwx","singleReview":"tr7oBwx","content":"w4Afjcf","end-quete":"lAN7Y8g","endQuete":"lAN7Y8g","text":"XaCFf1a"};